module.exports = __webpack_public_path__ + "fonts/DINNextLTPro-Medium.8b117b8e.ttf";